import { AppProviders } from './app/providers';
import { AppRoutes } from './app/AppRoutes';
import { MaintenanceGate } from './app/guards/MaintenanceGate';
import { useSessionBootstrap } from './features/auth/hooks/useSessionBootstrap';

function AppShell() {
  // Resolve the persisted session once before the router renders gated content.
  useSessionBootstrap();
  return (
    // Whole-app maintenance (set from the admin portal) replaces the router.
    <MaintenanceGate>
      <AppRoutes />
    </MaintenanceGate>
  );
}

export default function App() {
  return (
    <AppProviders>
      <AppShell />
    </AppProviders>
  );
}
